// App.js
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Breadcrumbs from './components/Layout/Breadcrumbs';
import Card1 from './components/Layout/Card1';
import ImageUploader from './components/Layout/ImageUploader';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './components/users/Signup'; // Importera din Register-komponent
import TestPage from './components/Layout/Testpage';
import CreateLog from './components/Layout/CreateLog';
import ShowLog from './components/Layout/ShowLog';
import CreateServiceLog from './components/Layout/CreateServiceLog';
import UpdateServiceLog from './components/Layout/UpdateServiceLog';
import ShowServiceLog from './components/Layout/ShowServiceLog';
import ServiceLogs from './components/Layout/ServiceLogs';
import ShowProfile from './components/Layout/ShowProfile';
import Info from './components/Layout/Info'; // Uppdatera sökvägen om det behövs
import UpdateLog from './components/Layout/UpdateLog';
import Blog from './components/Layout/Blog';
import LogTheme from './components/Layout/LogTheme';
import { useAuth } from './contexts/AuthContext';
import { AuthProvider } from './contexts/AuthContext';
import { LogbookProvider } from './contexts/LogbookContext';
import JoinLogbook from './components/Layout/JoinLogbook';
import YearLogs from './components/Layout/YearLogs';
import ChangeUser from './components/users/ChangeUser';
import ChangeProfile from './components/users/ChangeProfile';
import ResetPassword from './components/users/ResetPassword';
import VerifyEmail from './components/users/VerifyEmail';
import AdminDashboard from './components/Layout/AdminDashboard';
import Invitations from './components/Layout/Invitations';
import Subscription from './components/Layout/Subscription';
// New placeholder pages
import Pricing from './components/pages/Pricing';
import HowItWorks from './components/pages/HowItWorks';
import About from './components/pages/About';
import Privacy from './components/pages/Privacy';
import Terms from './components/pages/Terms';
import ScrollToTop from './components/Layout/ScrollToTop';
import SupportPanel from './components/Layout/SupportPanel';

function HomePage() {
  const { currentUser } = useAuth();
  return (
    <Box>
      {currentUser ? <Blog /> : <Info />}
    </Box>
  );
}

export default function LoggApp() {
  return (
    <AuthProvider>
      <LogbookProvider>
        <LogTheme>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Router>
              <ScrollToTop />
              <Header />
            <Box sx={{ flex: 1, pt: '64px' }}>
              <Routes>
                <Route path="/createlog" element={<CreateLog />} />
                <Route path="/updatelog/:log_id" element={<UpdateLog />} />
                <Route path="/showlog/:log_id" element={<ShowLog />} />
                <Route path="/createservicelog" element={<CreateServiceLog />} />
                <Route path="/updateservicelog/:log_id" element={<UpdateServiceLog />} />
                <Route path="/showservicelog/:id" element={<ShowServiceLog />} />
                <Route path="/servicelogs" element={<ServiceLogs />} />
                <Route path="/showprofile/:userid" element={<ShowProfile />} />
                <Route path="/changeprofile/:userid" element={<ChangeProfile />} />
                <Route path="/info" element={<Info />} />
                <Route path="/signup" element={<Register />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/" element={<HomePage />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/logs" element={<YearLogs />} />
                <Route path="/changeuser/:userId" element={<ChangeUser />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/invitations" element={<Invitations />} />
                <Route path="/join-logbook" element={<JoinLogbook />} />
                <Route path="/accept-invitation" element={<JoinLogbook />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/subscription/success" element={<Subscription />} />
                <Route path="/subscription/cancel" element={<Subscription />} />
                {/* New placeholder pages */}
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
              </Routes>
            </Box>
              <Footer />
              <SupportPanel />
            </Router>
          </Box>
        </LogTheme>
      </LogbookProvider>
    </AuthProvider>
  );
}
